module.exports = __webpack_public_path__ + "static/img/10bg_5.6c42565.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_5.png
// module id = 612
// module chunks = 1